import Immutable from 'immutable';

import { createModuleState } from 'ps-gui';
import { createSearchModel } from '../utils';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('AuthenticationCode');

export default class AuthenticationCodeModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setInitialized() {
		return new AuthenticationCodeModel(this.#data.set('initialized', true));
	}

	setSearch(model) {
		return new AuthenticationCodeModel(this.#data.set('search', model.getState()));
	}

	initialize() {
		let model = createSearchModel('/api/dq/sv_authentication_code').setEntityName('authenticationCode');
		return this.setSearch(model).#setInitialized();
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}

	getSearch() {
		return this.#data.get('search');
	}

	/**
	 * @param {Object} data 
	 * @returns this.#data
	 */
	setSearchData(data) {
		return this.#data.setIn(['search', 'data'], data);
	}
}

